// Report-definition for the Discrepancy Report. Code now; becomes a DB row in phase B.
// columns[] is the single source of truth for column order, labels, types, totals, drill.
export const discrepancies = {
   id: "discrepancies",
   title: "Discrepancy Report",
   family: "discrepancies",
   endpoint: "/runreport.sz", // each report has its own .sz page (no in-query branching)
   defaultSort: { key: "variance", dir: "desc" },
   groupBy: ["supplier"], // default; location / discrepancy_type are user regroup options
   groupOptions: [
      { value: "supplier",         label: "Supplier" },
      { value: "location",         label: "Location" },
      { value: "discrepancy_type", label: "Type" },
   ],
   categoryField: "discrepancy_type",
   categoryLabel: "Type",
   minField: "variance",
   params: [
      { key: "period", type: "month", label: "Period" },
      { key: "locations", type: "multiselect", label: "Locations" },
      { key: "suppliers", type: "multiselect", label: "Suppliers" },
      { key: "types", type: "multiselect", label: "Type",
        options: ["amount_variance","date_variance","on_statement_not_erp","in_erp_not_statement","unexpected_credit","partial_short"] },
      { key: "minVariance", type: "number", label: "Min $" },
   ],
   summary: [
      { key: "count",       label: "Discrepancies", type: "int",   agg: "count" },
      { key: "at_risk",     label: "$ At Risk",     type: "money", agg: "sumExposure" },
      { key: "net_variance",label: "Net Variance",  type: "money", agg: "sum", column: "variance" },
   ],
   columns: [
      { key: "supplier", label: "Supplier", type: "text", align: "left" },
      { key: "location", label: "Location", type: "text", align: "left" },
      { key: "invoice_no", label: "Invoice #", type: "text", align: "left", drill: "pair" },
      { key: "statement_date", label: "Stmt date", type: "date", align: "left" },
      { key: "invoice_date", label: "ERP date", type: "date", align: "left" },
      { key: "statement_amount", label: "Stmt amt", type: "money", align: "right", total: "sum" },
      { key: "erp_amount", label: "ERP amt", type: "money", align: "right", total: "sum" },
      { key: "variance", label: "Variance", type: "money", align: "right", total: "sum", drill: "pair", accent: true },
      { key: "days_diff", label: "Days", type: "int", align: "right" },
      { key: "discrepancy_type", label: "Type", type: "text", align: "left" },
   ],
};
